import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { toast, ToastContainer } from 'react-toastify';
import { fruitOptions,vegetableOptions } from '../../../../core/data/json/role';
import { approveRejectApmcDetailApplication, newOneTimeDocUpload } from '../../../auth/services/privateapicalling';

interface SelectOption {
  value: any;
  label: string;
}

interface SubYard {
  name: string;
  date: string;
  address: string;
  doc: string | null;
}

interface ResubmissionFormProps {
  applicationId: any;
  rejectedFieldName: any;
  rejectedDocName: any[];
  talukaOptions: SelectOption[];
  spicesOptions: SelectOption[];
  rawPurposes: SelectOption[];
  onSubmitSuccess: () => void;
}

const ResubmissionForm: React.FC<ResubmissionFormProps> = ({
  applicationId,
  rejectedFieldName,
  rejectedDocName,
  talukaOptions,
  spicesOptions,
  rawPurposes,
  onSubmitSuccess
}) => {
  const token = useSelector((state: any) => state.auth.token);
  const [formData, setFormData] = useState<any>({});
  const[resubmitDocs,setResubmitDocs]=useState<any>({});
   const [comment , setComment] = useState<string>("");
  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  

  
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
    setErrors((prev: any) => ({ ...prev, [name]: '' }));
  };

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string,
    subYardIndex?: number
  ) => {
    const { name, files } = e.target;
    if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;

      let docId = null;
      if (subYardIndex !== undefined) {
        docId = formData.subYards?.[subYardIndex]?.doc || null;
      } else {
        docId = resubmitDocs[fieldName] || null;
      }

      handleUpload(name, file, fieldName, docId, fileName, subYardIndex);
    }
  };

  const handleUpload = async (
    documentName: string,
    file: any,
    fieldName: string,
    docId?: string | null,
    fileName?: string,
    subYardIndex?: number
  ) => {
    const uploadFormData = new FormData();
    uploadFormData.append("file", file);
    uploadFormData.append("documentName", documentName);
    uploadFormData.append("fieldName", fieldName);
    uploadFormData.append("applicationId", applicationId?.applicationId);

    try {
      setLoading(true);
      const res = await newOneTimeDocUpload(token, uploadFormData, docId);

      if (res.success === false) {
        toast.error(res.message, {
          position: "top-right",
          style: { fontSize: "1.2rem", padding: "16px" }
        });
      } else if (res?.success && res?.docId) {
        if (subYardIndex !== undefined) {
          setFormData((prev: any) => ({
            ...prev,
            subYards: prev.subYards?.map((yard: SubYard, i: number) =>
              i === subYardIndex ? { ...yard, doc: res.docId } : yard
            ),
          }));
        } else {

            if(fieldName==="mainYardDoc")

                {
                      setFormData((prev: any) => ({
            ...prev,
            [fieldName]: res.docId
          }));
        
                }
                else{
          setResubmitDocs((prev: any) => ({
            ...prev,
            [fieldName]: res.docId
          }));
        }
}
        toast.success("File uploaded successfully", {
          position: "top-right",
          style: { fontSize: "1.2rem", padding: "16px" }
        });
      }
    } catch (error) {
      toast.error("File upload failed", {
        position: "top-right",
        style: { fontSize: "1.2rem", padding: "16px" }
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubYardChange = (
    index: number,
    field: 'name' | 'date' | 'address',
    value: string
  ) => {
    setFormData((prev: any) => ({
      ...prev,
      subYards: prev.subYards?.map((yard: SubYard, i: number) =>
        i === index ? { ...yard, [field]: value } : yard
      ),
    }));
  };

  const handleAddSubYard = () => {
    setFormData((prev: any) => ({
      ...prev,
      subYards: [
        ...(prev.subYards || []),
        { name: '', date: '', address: '', doc: null }
      ],
    }));
  };

  const handleRemoveSubYard = (index: number) => {
    if (formData.subYards && formData.subYards.length > 1) {
      setFormData((prev: any) => ({
        ...prev,
        subYards: prev.subYards?.filter((_: any, i: number) => i !== index),
      }));
    }
  };

  const validateForm = () => {
    const newErrors: any = {};

    // Validate based on rejected fields
 
    // Validate based on rejected fields
    if (rejectedFieldName.talukasName && (!formData.taluka || formData.taluka.length === 0)) {
      newErrors.taluka = "Please select at least one taluka";
    }

    if (rejectedFieldName.registrationDate && !formData.registrationDate) {
      newErrors.registrationDate = "Registration date is required";
    }

    if (rejectedFieldName.noOfVillagesmarket && !formData.noOfVillagesmarket) {
      newErrors.noOfVillagesmarket = "Number of villages is required";
    }

    if (rejectedFieldName.emailID && !formData.emailID) {
      newErrors.emailID = "Email ID is required";
    }

    if (rejectedFieldName.chairmanName && !formData.chairmanName) {
      newErrors.chairmanName = "Chairman name is required";
    }

    if (rejectedFieldName.chairmanMobileNo && !formData.chairmanMobileNo) {
      newErrors.chairmanMobileNo = "Chairman mobile number is required";
    }

    if (rejectedFieldName.secreataryName && !formData.secreataryName) {
      newErrors.secreataryName = "Secretary name is required";
    }

    if (rejectedFieldName.secreataryMobileNo && !formData.secreataryMobileNo) {
      newErrors.secreataryMobileNo = "Secretary mobile number is required";
    }

    if (rejectedFieldName.noOfFarmerApmc && !formData.noOfFarmerApmc) {
      newErrors.noOfFarmerApmc = "Number of farmers is required";
    }

    if (rejectedFieldName.noOfTraderApmc && !formData.noOfTraderApmc) {
      newErrors.noOfTraderApmc = "Number of traders is required";
    }

    if (rejectedFieldName.noOfAgentsApmc && !formData.noOfAgentsApmc) {
      newErrors.noOfAgentsApmc = "Number of agents is required";
    }

    if (rejectedFieldName.noOfSocietesApmc && !formData.noOfSocietesApmc) {
      newErrors.noOfSocietesApmc = "Number of societies is required";
    }
     if (rejectedFieldName.otherCommoditiesInApmc && !formData.otherCommodities) {
      newErrors.otherCommodities = "Other Commodities  is required";
    }
       if (rejectedFieldName.detailsInfrastructureFacilities && !formData.infrastructureDetails) {
      newErrors.infrastructureDetails = "Infrastructure facilities  is required";
    }

    if (rejectedFieldName.lastElectionDate && !formData.lastElectionDate) {
      newErrors.lastElectionDate = "Last election date is required";
    }

    if (rejectedFieldName.noOfunifiedLicense && !formData.noOfunifiedLicense) {
      newErrors.noOfunifiedLicense = "Number of unified license is required";
    }

    if (rejectedFieldName.noOfgca && !formData.noOfgca) {
      newErrors.noOfgca = "Number of GCA is required";
    }

    if (rejectedFieldName.noOfotherLicense && !formData.noOfotherLicense) {
      newErrors.noOfotherLicense = "Number of other license is required";
    }

    if (rejectedFieldName.lastAuditDate && !formData.lastAuditDate) {
      newErrors.lastAuditDate = "Last audit date is required";
    }

    if (rejectedFieldName.totalApprovlStaff && !formData.totalApprovlStaff) {
      newErrors.totalApprovlStaff = "Total approval staff is required";
    }

    if (rejectedFieldName.totalRecruitStaff && !formData.totalRecruitStaff) {
      newErrors.totalRecruitStaff = "Total recruit staff is required";
    }

    // Validate main yard if rejected
    if (rejectedFieldName.mainYardDetails) {
      if (!formData.mainYardName) newErrors.mainYardName = "Main yard name is required";
      if (!formData.mainYardDate) newErrors.mainYardDate = "Main yard date is required";
      if (!formData.mainYardAddress) newErrors.mainYardAddress = "Main yard address is required";
      if(!formData?.mainYardDoc)newErrors.mainYardDoc="Main Yard Document is required"
    }
 if (rejectedFieldName.isTradingFruitVeg) {
      if (!formData.tradingVegetablesFruits) {
        newErrors.tradingVegetablesFruits = "Please select Yes or No";
      }
      if (formData.tradingVegetablesFruits === "yes") {
        if (!formData.vegetables || formData.vegetables.length === 0) {
          newErrors.vegetables = "Please select at least one vegetable";
        }
        if (!formData.fruits || formData.fruits.length === 0) {
          newErrors.fruits = "Please select at least one fruit";
        }
      }
    }

    // Validate canteen facility
    if (rejectedFieldName.apmcCanteenFacility) {
      if (!formData.hasCanteen) {
        newErrors.hasCanteen = "Please select Yes or No";
      }
      if (formData.hasCanteen === "yes" && !formData.canteenSeatingCapacity) {
        newErrors.canteenSeatingCapacity = "Seating capacity is required";
      }
    }

    // Validate guest house facility
    if (rejectedFieldName.apmcGuestHouse) {
      if (!formData.hasGuestHouse) {
        newErrors.hasGuestHouse = "Please select Yes or No";
      }
      if (formData.hasGuestHouse === "yes" && !formData.noOfBeds) {
        newErrors.noOfBeds = "Number of beds is required";
      }
    }

    // Validate private land
    if (rejectedFieldName.apmcPrivateLand) {
      if (!formData.hasPrivateLand) {
        newErrors.hasPrivateLand = "Please select Yes or No";
      }
      if (formData.hasPrivateLand === "yes") {
        if (!formData.landHectare) newErrors.landHectare = "Hectare is required";
        if (!formData.landAre) newErrors.landAre = "Are is required";
        if (!formData.landSqMeter) newErrors.landSqMeter = "Sq Meter is required";
      }
    }

    // Validate leased land
    if (rejectedFieldName.apmcLeaseLand) {
      if (!formData.hasLeasedLand) {
        newErrors.hasLeasedLand = "Please select Yes or No";
      }
      if (formData.hasLeasedLand === "yes") {
        if (!formData.leaseLandHectare) newErrors.leaseLandHectare = "Hectare is required";
        if (!formData.leaseLandAre) newErrors.leaseLandAre = "Are is required";
        if (!formData.leaseLandSqMeter) newErrors.leaseLandSqMeter = "Sq Meter is required";
        if (!formData.leasePeriodYears) newErrors.leasePeriodYears = "Lease period is required";
      }
    }

    // Validate sub yards if rejected
    if (rejectedFieldName.subYardDetails && formData.subYards) {
      formData.subYards.forEach((yard: SubYard, index: number) => {
        if (!yard.name) newErrors[`subYards[${index}].name`] = "Sub yard name is required";
        if (!yard.date) newErrors[`subYards[${index}].date`] = "Sub yard date is required";
        if (!yard.address) newErrors[`subYards[${index}].address`] = "Sub yard address is required";
        if(!yard.doc)newErrors[`subYards[${index}].doc`]="Document is required"
      });
    }

    // Validate rejected documents
    rejectedDocName?.forEach((doc: any) => {
      if (!resubmitDocs[doc.docName]) {
        newErrors[doc.docName] = "This document is required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (status:string,appStatusLevel:string) => {
    if (!validateForm()) {
      toast.error("Please fill all required fields", {
        position: "top-right",
        style: { fontSize: "1.2rem", padding: "16px" }
      });
      return;
    }
if(comment=='')
    {
      toast.error("Comment is required");
     
      return;
    }
    try {
      setSubmitLoading(true);

      // Prepare submission data
      const submissionData: any = {
      
      };

      // Add rejected field values
      if (rejectedFieldName?.talukasName) {
        submissionData.talukasName = formData?.taluka?.map((t: SelectOption) => t.value);
      }

      if (rejectedFieldName?.registrationDate) {
        submissionData.registrationDate = formData?.registrationDate;
      }

      if (rejectedFieldName?.noOfVillagesmarket) {
        submissionData.noOfVillagesmarket = formData?.noOfVillagesmarket;
      }

      if (rejectedFieldName?.emailID) {
        submissionData.emailID = formData?.emailID;
      }

      if (rejectedFieldName?.chairmanName) {
        submissionData.chairmanName = formData?.chairmanName;
      }

      if (rejectedFieldName?.chairmanMobileNo) {
        submissionData.chairmanMobileNo = formData?.chairmanMobileNo;
      }

      if (rejectedFieldName?.secreataryName) {
        submissionData.secreataryName = formData?.secreataryName;
      }

      if (rejectedFieldName?.secreataryMobileNo) {
        submissionData.secreataryMobileNo = formData?.secreataryMobileNo;
      }

      if (rejectedFieldName?.noOfFarmerApmc) {
        submissionData.noOfFarmerApmc = formData?.noOfFarmerApmc;
      }

      if (rejectedFieldName?.noOfTraderApmc) {
        submissionData.noOfTraderApmc = formData?.noOfTraderApmc;
      }

      if (rejectedFieldName?.noOfAgentsApmc) {
        submissionData.noOfAgentsApmc = formData?.noOfAgentsApmc;
      }

      if (rejectedFieldName?.noOfSocietesApmc) {
        submissionData.noOfSocietesApmc = formData?.noOfSocietesApmc;
      }

      if (rejectedFieldName?.lastElectionDate) {
        submissionData.lastElectionDate = formData?.lastElectionDate;
      }

      if (rejectedFieldName?.noOfunifiedLicense) {
        submissionData.noOfunifiedLicense = formData?.noOfunifiedLicense;
      }

      if (rejectedFieldName?.noOfgca) {
        submissionData.noOfgca = formData.noOfgca;
      }

      if (rejectedFieldName?.noOfotherLicense) {
        submissionData.noOfotherLicense = formData?.noOfotherLicense;
      }

      if (rejectedFieldName?.lastAuditDate) {
        submissionData.lastAuditDate = formData?.lastAuditDate;
      }

      if (rejectedFieldName?.totalApprovlStaff) {
        submissionData.totalApprovlStaff = formData?.totalApprovlStaff;
      }

      if (rejectedFieldName?.totalRecruitStaff) {
        submissionData.totalRecruitStaff = formData?.totalRecruitStaff;
      }

      if (rejectedFieldName?.otherCommoditiesInApmc) {
        submissionData.otherCommoditiesInApmc = formData?.otherCommodities?.map((c: SelectOption) => c.label);
      }

      if (rejectedFieldName?.detailsInfrastructureFacilities) {
        submissionData.detailsInfrastructureFacilities = formData?.infrastructureDetails?.map((f: SelectOption) => ({
          id: f.value,
          value: f.label
        }));
      }

      if (rejectedFieldName?.mainYardDetails) {
        submissionData.mainYardDetails = [{
          name: formData?.mainYardName,
          date: formData?.mainYardDate,
          address: formData?.mainYardAddress,
          doc: formData?.mainYardDoc
        }];
      }

      if (rejectedFieldName?.subYardDetails) {
        submissionData.subYardDetails = formData?.subYards;
      }
    if (rejectedFieldName.isTradingFruitVeg) {
        submissionData.isTradingFruitVeg = [
          {
            fieldName: "isfruitvegetable",
            value: formData.tradingVegetablesFruits
          }
        ];

        if (formData.tradingVegetablesFruits === "yes") {
          submissionData.isTradingFruitVeg.push(
            {
              fieldName: "vegetables",
              value: formData.vegetables?.map((v: SelectOption) => v.value) || []
            },
            {
              fieldName: "fruits",
              value: formData.fruits?.map((f: SelectOption) => f.value) || []
            }
          );
        }
      }

      // Add canteen facility data
      if (rejectedFieldName.apmcCanteenFacility) {
        submissionData.apmcCanteenFacility = [
          {
            fieldName: "hasCanteen",
            value: formData.hasCanteen
          }
        ];

        if (formData.hasCanteen === "yes") {
          submissionData.apmcCanteenFacility.push({
            fieldName: "seatingCapacity",
            value: formData.canteenSeatingCapacity
          });
        }
      }

      // Add guest house facility data
      if (rejectedFieldName.apmcGuestHouse) {
        submissionData.apmcGuestHouse = [
          {
            fieldName: "hasGuestRoom",
            value: formData.hasGuestHouse
          }
        ];

        if (formData.hasGuestHouse === "yes") {
          submissionData.apmcGuestHouse.push({
            fieldName: "bedCapacity",
            value: formData.noOfBeds
          });
        }
      }

      // Add private land data
      if (rejectedFieldName.apmcPrivateLand) {
        submissionData.apmcPrivateLand = [
          {
            fieldName: "hasPrivateLand",
            value: formData.hasPrivateLand
          }
        ];

        if (formData.hasPrivateLand === "yes") {
          submissionData.apmcPrivateLand.push(
            {
              fieldName: "hectare",
              value: formData.landHectare
            },
            {
              fieldName: "area",
              value: formData.landAre
            },
            {
              fieldName: "sqmeter",
              value: formData.landSqMeter
            }
          );
        }
      }

      // Add leased land data
      if (rejectedFieldName.apmcLeaseLand) {
        submissionData.apmcLeaseLand = [
          {
            fieldName: "hasPrivateLand",
            value: formData.hasLeasedLand
          }
        ];

        if (formData.hasLeasedLand === "yes") {
          submissionData.apmcLeaseLand.push(
            {
              fieldName: "hectare",
              value: formData.leaseLandHectare
            },
            {
              fieldName: "area",
              value: formData.leaseLandAre
            },
            {
              fieldName: "sqmeter",
              value: formData.leaseLandSqMeter
            },
            {
              fieldName: "leasePeriod",
              value: formData.leasePeriodYears
            }
          );
        }
      }
    
    const finalBody = {
      reSubmittedFields: submissionData,
      comment: comment,
      reSubmittedDocs: resubmitDocs,
      status: status,
      appStatusLevel: appStatusLevel,
      applicationId: applicationId?.applicationId,
      rejectedDocName: [],
      rejectedFieldName: [],
    };
   
      
       const response = await approveRejectApmcDetailApplication(token, finalBody);
        if (response?.success) {
      toast.success("Application resubmitted successfully", {
        position: "top-right",
        style: { fontSize: "1.2rem", padding: "16px" }
      });

      onSubmitSuccess();
    }else{
      toast.error(response?.message, {
        position: "top-right",
        style: { fontSize: "1.2rem", padding: "16px" }
      });

    }
    } catch (error) {
     
      toast.error("Failed to resubmit application", {
        position: "top-right",
        style: { fontSize: "1.2rem", padding: "16px" }
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // Check if a field or document is rejected
  const isFieldRejected = (fieldName: string) => {
    return rejectedFieldName && rejectedFieldName[fieldName] !== undefined;
  };

  const isDocRejected = (docName: string) => {
    return rejectedDocName?.some((doc: any) => doc.docName === docName);
  };

  return (
    <div className="resubmission-form-container mt-4">
      {submitLoading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
             style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
          <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Submitting...</span>
            </div>
            <div className="fw-bold">Resubmitting, please wait...</div>
          </div>
        </div>
      )}

      <div className="alert alert-warning">
        <h5>⚠️ Resubmission Required</h5>
        <p>Please update the following rejected fields and documents:</p>
      </div>

      <div className="border rounded bg-white">
        {/* Registration Date */}
        {isFieldRejected('registrationDate') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Registration Date *</strong>
            </div>
            <div className="col-6 p-3">
              <input
                className="form-control"
                type="date"
                name="registrationDate"
                value={formData.registrationDate || ""}
                onChange={handleInputChange}
              />
              {errors.registrationDate && (
                <small className="text-danger">{errors.registrationDate}</small>
              )}
            </div>
          </div>
        )}

        {/* Registration Document */}
        {isDocRejected('registrationDoc') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Registration Document *</strong>
            </div>
            <div className="col-6 p-3">
              <input
                className="form-control"
                type="file"
                name="registrationDoc"
                onChange={(e) => handleFileChange(e, "registrationDoc")}
                accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
              />
              {resubmitDocs.registrationDoc && (
                <small className="text-success">✓ Uploaded</small>
              )}
              {errors.registrationDoc && (
                <small className="text-danger">{errors.registrationDoc}</small>
              )}
            </div>
          </div>
        )}

        {/* Talukas */}
        {isFieldRejected('talukasName') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Select Talukas *</strong>
            </div>
            <div className="col-6 p-3">
              <Select
                isMulti
                options={talukaOptions}
                placeholder="Select Taluka"
                value={formData.taluka}
                onChange={(selected) => {
                  setFormData((prev: any) => ({ ...prev, taluka: selected }));
                  setErrors((prev: any) => ({ ...prev, taluka: "" }));
                }}
              />
              {errors.taluka && (
                <small className="text-danger">{errors.taluka}</small>
              )}
            </div>
          </div>
        )}

        {/* Number of Villages */}
        {isFieldRejected('noOfVillagesmarket') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Number of Villages *</strong>
            </div>
            <div className="col-6 p-3">
              <input
                className="form-control"
                type="number"
                name="noOfVillagesmarket"
                value={formData.noOfVillagesmarket || ""}
                onChange={handleInputChange}
                placeholder="Enter number of villages"
              />
              {errors.noOfVillagesmarket && (
                <small className="text-danger">{errors.noOfVillagesmarket}</small>
              )}
            </div>
          </div>
        )}
           {isFieldRejected('emailID') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Email Id *</strong>
            </div>
            <div className="col-6 p-3">
              <input
                className="form-control"
                // type="number"
                name="emailID"
                value={formData.emailID || ""}
                onChange={handleInputChange}
                placeholder="Enter emailId"
              />
              {errors.emailID && (
                <small className="text-danger">{errors.emailID}</small>
              )}
            </div>
          </div>
        )}
         {isFieldRejected('chairmanName') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Chairman Name *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="text"
                        name="chairmanName"
                        value={formData.chairmanName || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Chairman Name"
                      />
                      {errors.chairmanName && (
                        <small className="text-danger">{errors.chairmanName}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Chairman Mobile No */}
                {isFieldRejected('chairmanMobileNo') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Chairman Mobile No *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="tel"
                        name="chairmanMobileNo"
                        value={formData.chairmanMobileNo || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Chairman Mobile No"
                        maxLength={10}
                      />
                      {errors.chairmanMobileNo && (
                        <small className="text-danger">{errors.chairmanMobileNo}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Secretary Name */}
                {isFieldRejected('secreataryName') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Secretary Name *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="text"
                        name="secreataryName"
                        value={formData.secreataryName || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Secretary Name"
                      />
                      {errors.secreataryName && (
                        <small className="text-danger">{errors.secreataryName}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Secretary Mobile No */}
                {isFieldRejected('secreataryMobileNo') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Secretary Mobile No *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="tel"
                        name="secreataryMobileNo"
                        value={formData.secreataryMobileNo || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Secretary Mobile No"
                        maxLength={10}
                      />
                      {errors.secreataryMobileNo && (
                        <small className="text-danger">{errors.secreataryMobileNo}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Number of Farmers APMC */}
                {isFieldRejected('noOfFarmerApmc') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Number of Farmers APMC *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="noOfFarmerApmc"
                        value={formData.noOfFarmerApmc || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number of Farmers"
                      />
                      {errors.noOfFarmerApmc && (
                        <small className="text-danger">{errors.noOfFarmerApmc}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Number of Traders APMC */}
                {isFieldRejected('noOfTraderApmc') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Number of Traders APMC *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="noOfTraderApmc"
                        value={formData.noOfTraderApmc || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number of Traders"
                      />
                      {errors.noOfTraderApmc && (
                        <small className="text-danger">{errors.noOfTraderApmc}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Number of Agents APMC */}
                {isFieldRejected('noOfAgentsApmc') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Number of Agents APMC *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="noOfAgentsApmc"
                        value={formData.noOfAgentsApmc || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number of Agents"
                      />
                      {errors.noOfAgentsApmc && (
                        <small className="text-danger">{errors.noOfAgentsApmc}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Number of Societies APMC */}
                {isFieldRejected('noOfSocietesApmc') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Number of Societies APMC *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="noOfSocietesApmc"
                        value={formData.noOfSocietesApmc || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number of Societies"
                      />
                      {errors.noOfSocietesApmc && (
                        <small className="text-danger">{errors.noOfSocietesApmc}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Last Election Date */}
                {isFieldRejected('lastElectionDate') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Last Election Date *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="date"
                        name="lastElectionDate"
                        value={formData.lastElectionDate || ""}
                        onChange={handleInputChange}
                      />
                      {errors.lastElectionDate && (
                        <small className="text-danger">{errors.lastElectionDate}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Number of Unified License */}
                {isFieldRejected('noOfunifiedLicense') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Number of Unified License *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="noOfunifiedLicense"
                        value={formData.noOfunifiedLicense || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number"
                      />
                      {errors.noOfunifiedLicense && (
                        <small className="text-danger">{errors.noOfunifiedLicense}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Number of GCA */}
                {isFieldRejected('noOfgca') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Number of GCA *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="noOfgca"
                        value={formData.noOfgca || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number"
                      />
                      {errors.noOfgca && (
                        <small className="text-danger">{errors.noOfgca}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Number of Other License */}
                {isFieldRejected('noOfotherLicense') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Number of Other License *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="noOfotherLicense"
                        value={formData.noOfotherLicense || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number"
                      />
                      {errors.noOfotherLicense && (
                        <small className="text-danger">{errors.noOfotherLicense}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Last Audit Date */}
                {isFieldRejected('lastAuditDate') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Last Audit Date *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="date"
                        name="lastAuditDate"
                        value={formData.lastAuditDate || ""}
                        onChange={handleInputChange}
                      />
                      {errors.lastAuditDate && (
                        <small className="text-danger">{errors.lastAuditDate}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Total Approval Staff */}
                {isFieldRejected('totalApprovlStaff') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Total Approval Staff *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="totalApprovlStaff"
                        value={formData.totalApprovlStaff || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number"
                      />
                      {errors.totalApprovlStaff && (
                        <small className="text-danger">{errors.totalApprovlStaff}</small>
                      )}
                    </div>
                  </div>
                )}

                {/* Total Recruit Staff */}
                {isFieldRejected('totalRecruitStaff') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Total Recruit Staff *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="number"
                        name="totalRecruitStaff"
                        value={formData.totalRecruitStaff || ""}
                        onChange={handleInputChange}
                        placeholder="Enter Number"
                      />
                      {errors.totalRecruitStaff && (
                        <small className="text-danger">{errors.totalRecruitStaff}</small>
                      )}
                    </div>
                  </div>
                )}
        {/* Other Commodities */}
        {isFieldRejected('otherCommoditiesInApmc') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Other Commodities</strong>
            </div>
            <div className="col-6 p-3">
              <Select
                isMulti
                options={spicesOptions}
                value={formData.otherCommodities}
                placeholder="Select Commodities"
                onChange={(selected) => {
                  setFormData((prev: any) => ({ ...prev, otherCommodities: selected }));
                  setErrors((prev: any) => ({ ...prev, otherCommodities: "" }));
                }}
              />
              {errors.otherCommodities && (
                <small className="text-danger">{errors.otherCommodities}</small>
              )}
            </div>
          </div>
        )}

        {/* Infrastructure Facilities */}
        {isFieldRejected('detailsInfrastructureFacilities') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Infrastructure Facilities</strong>
            </div>
            <div className="col-6 p-3">
              <Select
                isMulti
                options={rawPurposes}
                value={formData.infrastructureDetails}
                placeholder="Select Infrastructure Facilities"
                onChange={(selected) => {
                  setFormData((prev: any) => ({ ...prev, infrastructureDetails: selected }));
                  setErrors((prev: any) => ({ ...prev, infrastructureDetails: "" }));
                }}
              />
              {errors.infrastructureDetails && (
                <small className="text-danger">{errors.infrastructureDetails}</small>
              )}
            </div>
          </div>
        )}

        {/* Land Details */}
       {/* Private Land */}
        {isFieldRejected('apmcPrivateLand') && (
          <>
            <div className="d-flex border-bottom border-secondary">
              <div className="col-6 p-3 bg-light">
                <strong>Whether APMC has Private Land? *</strong>
              </div>
              <div className="col-6 p-3">
                <div className="d-flex gap-3">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasPrivateLand"
                      value="yes"
                      checked={formData.hasPrivateLand === "yes"}
                      onChange={handleInputChange}
                    />
                    Yes
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasPrivateLand"
                      value="no"
                      checked={formData.hasPrivateLand === "no"}
                      onChange={handleInputChange}
                    />
                    No
                  </label>
                </div>
                 {errors?.hasPrivateLand && (
                        <small className="text-danger">{errors.hasPrivateLand}</small>
                      )}
              </div>
            </div>
              
            {formData.hasPrivateLand === "yes" && (
              <div className="d-flex border-bottom border-secondary">
                <div className="col-6 p-3 bg-light">
                  <strong>Land Area - Hectare – Area – Sq. Meter *</strong>
                </div>
                <div className="col-6 p-3">
                  <div className="d-flex gap-2">
                    <div className="flex-fill">
                      <input
                        type="number"
                        className="form-control"
                        name="landHectare"
                        placeholder="Hectare"
                        value={formData.landHectare || ""}
                        onChange={handleInputChange}
                        min="0"
                      />
                      {errors?.landHectare && (
                        <small className="text-danger">{errors.landHectare}</small>
                      )}
                    </div>
                    <div className="flex-fill">
                      <input
                        type="number"
                        className="form-control"
                        name="landAre"
                        placeholder="Area"
                        value={formData.landAre || ""}
                        onChange={handleInputChange}
                        min="0"
                      />
                      {errors?.landAre && (
                        <small className="text-danger">{errors.landAre}</small>
                      )}
                    </div>
                    <div className="flex-fill">
                      <input
                        type="number"
                        className="form-control"
                        name="landSqMeter"
                        placeholder="Sq. Meter"
                        value={formData.landSqMeter || ""}
                        onChange={handleInputChange}
                        min="0"
                      />
                      {errors?.landSqMeter && (
                        <small className="text-danger">{errors.landSqMeter}</small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {/* Leased Land */}
        {isFieldRejected('apmcLeaseLand') && (
          <>
            <div className="d-flex border-bottom border-secondary">
              <div className="col-6 p-3 bg-light">
                <strong>Whether APMC has Land on Lease? *</strong>
              </div>
              <div className="col-6 p-3">
                <div className="d-flex gap-3">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasLeasedLand"
                      value="yes"
                      checked={formData.hasLeasedLand === "yes"}
                      onChange={handleInputChange}
                    />
                    Yes
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasLeasedLand"
                      value="no"
                      checked={formData.hasLeasedLand === "no"}
                      onChange={handleInputChange}
                    />
                    No
                  </label>
                </div>
                 {errors?.hasLeasedLand && (
                        <small className="text-danger">{errors.hasLeasedLand}</small>
                      )}
              </div>
            </div>

            {formData.hasLeasedLand === "yes" && (
              <>
                <div className="d-flex border-bottom border-secondary">
                  <div className="col-6 p-3 bg-light">
                    <strong>Land Area - Hectare – Area – Sq. Meter *</strong>
                  </div>
                  <div className="col-6 p-3">
                    <div className="d-flex gap-2">
                      <div className="flex-fill">
                        <input
                          type="number"
                          className="form-control"
                          name="leaseLandHectare"
                          placeholder="Hectare"
                          value={formData.leaseLandHectare || ""}
                          onChange={handleInputChange}
                          min="0"
                        />
                        {errors?.leaseLandHectare && (
                          <small className="text-danger">{errors.leaseLandHectare}</small>
                        )}
                      </div>
                      <div className="flex-fill">
                        <input
                          type="number"
                          className="form-control"
                          name="leaseLandAre"
                          placeholder="Area"
                          value={formData.leaseLandAre || ""}
                          onChange={handleInputChange}
                          min="0"
                        />
                        {errors?.leaseLandAre && (
                          <small className="text-danger">{errors.leaseLandAre}</small>
                        )}
                      </div>
                      <div className="flex-fill">
                        <input
                          type="number"
                          className="form-control"
                          name="leaseLandSqMeter"
                          placeholder="Sq. Meter"
                          value={formData.leaseLandSqMeter || ""}
                          onChange={handleInputChange}
                          min="0"
                        />
                        {errors?.leaseLandSqMeter && (
                          <small className="text-danger">{errors.leaseLandSqMeter}</small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex border-bottom border-secondary">
                  <div className="col-6 p-3 bg-light">
                    <strong>Lease Period in Years *</strong>
                  </div>
                  <div className="col-6 p-3">
                    <input
                      type="number"
                      className="form-control"
                      name="leasePeriodYears"
                      placeholder="Enter Lease Period in Years"
                      value={formData.leasePeriodYears || ""}
                      onChange={handleInputChange}
                      min="0"
                    />
                    {errors?.leasePeriodYears && (
                      <small className="text-danger">{errors.leasePeriodYears}</small>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {/* Canteen Facility */}
        {isFieldRejected('apmcCanteenFacility') && (
          <>
            <div className="d-flex border-bottom border-secondary">
              <div className="col-6 p-3 bg-light">
                <strong>Whether APMC has Canteen Facility? *</strong>
              </div>
              <div className="col-6 p-3">
                <div className="d-flex gap-3">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasCanteen"
                      value="yes"
                      checked={formData.hasCanteen === "yes"}
                      onChange={handleInputChange}
                    />
                    Yes
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasCanteen"
                      value="no"
                      checked={formData.hasCanteen === "no"}
                      onChange={handleInputChange}
                    />
                    No
                  </label>
                </div>
                  {errors?.hasCanteen && (
                      <small className="text-danger">{errors.hasCanteen}</small>
                    )}
              </div>
            </div>

            {formData.hasCanteen === "yes" && (
              <div className="d-flex border-bottom border-secondary">
                <div className="col-6 p-3 bg-light">
                  <strong>Canteen Seating Capacity *</strong>
                </div>
                <div className="col-6 p-3">
                  <input
                    type="number"
                    className="form-control"
                    name="canteenSeatingCapacity"
                    placeholder="Enter Seating Capacity"
                    value={formData.canteenSeatingCapacity || ""}
                    onChange={handleInputChange}
                    min="0"
                  />
                  {errors?.canteenSeatingCapacity && (
                    <small className="text-danger">{errors.canteenSeatingCapacity}</small>
                  )}
                </div>
              </div>
            )}
          </>
        )}

        {/* Guest House */}
        {isFieldRejected('apmcGuestHouse') && (
          <>
            <div className="d-flex border-bottom border-secondary">
              <div className="col-6 p-3 bg-light">
                <strong>Whether APMC has Guest House / Rest House? *</strong>
              </div>
              <div className="col-6 p-3">
                <div className="d-flex gap-3">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasGuestHouse"
                      value="yes"
                      checked={formData.hasGuestHouse === "yes"}
                      onChange={handleInputChange}
                    />
                    Yes
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="hasGuestHouse"
                      value="no"
                      checked={formData.hasGuestHouse === "no"}
                      onChange={handleInputChange}
                    />
                    No
                  </label>
                </div>
                  {errors?.hasGuestHouse && (
                    <small className="text-danger">{errors.hasGuestHouse}</small>
                  )}
              </div>
            </div>

            {formData.hasGuestHouse === "yes" && (
              <div className="d-flex border-bottom border-secondary">
                <div className="col-6 p-3 bg-light">
                  <strong>Number of Beds</strong>
                </div>
                <div className="col-6 p-3">
                  <input
                    type="number"
                    className="form-control"
                    name="noOfBeds"
                    placeholder="Enter Number of Beds"
                    value={formData.noOfBeds || ""}
                    onChange={handleInputChange}
                    min="0"
                  />
                  {errors?.noOfBeds && (
                    <small className="text-danger">{errors.noOfBeds}</small>
                  )}
                </div>
              </div>
            )}
          </>
        )}

        {/* Trading Vegetables & Fruits */}
        {isFieldRejected('isTradingFruitVeg') && (
          <>
            <div className="d-flex border-bottom border-secondary">
              <div className="col-6 p-3 bg-light">
                <strong>Trading in Vegetables & Fruits *</strong>
              </div>
              <div className="col-6 p-3">
                <div className="d-flex gap-3">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="tradingVegetablesFruits"
                      value="yes"
                      checked={formData.tradingVegetablesFruits === "yes"}
                      onChange={handleInputChange}
                    />
                    Yes
                  </label>
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="tradingVegetablesFruits"
                      value="no"
                      checked={formData.tradingVegetablesFruits === "no"}
                      onChange={handleInputChange}
                    />
                    No
                  </label>
                </div>
                     {errors?.tradingVegetablesFruits && (
                      <small className="text-danger">{errors.tradingVegetablesFruits}</small>
                    )}
              </div>
            </div>

            {formData.tradingVegetablesFruits === "yes" && (
              <>
                <div className="d-flex border-bottom border-secondary">
                  <div className="col-6 p-3 bg-light">
                    <strong>Vegetables</strong>
                  </div>
                  <div className="col-6 p-3">
                    <Select
                      isMulti
                      options={vegetableOptions}
                      value={formData.vegetables}
                      onChange={(selected) => {
                        setFormData((prev) => ({
                          ...prev,
                          vegetables: selected,
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          vegetables: "",
                        }));
                      }}
                    />
                    {errors?.vegetables && (
                      <small className="text-danger">{errors.vegetables}</small>
                    )}
                  </div>
                </div>

                <div className="d-flex border-bottom border-secondary">
                  <div className="col-6 p-3 bg-light">
                    <strong>Fruits</strong>
                  </div>
                  <div className="col-6 p-3">
                    <Select
                      isMulti
                      options={fruitOptions}
                      value={formData.fruits}
                      onChange={(selected) => {
                        setFormData((prev) => ({
                          ...prev,
                          fruits: selected,
                        }));
                        setErrors((prev) => ({
                          ...prev,
                          fruits: "",
                        }));
                      }}
                    />
                    {errors?.fruits && (
                      <small className="text-danger">{errors.fruits}</small>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        )}
 {/* Election Result Document */}
        {isDocRejected('electionResultDoc') && (
          <div className="d-flex border-bottom border-secondary">
            <div className="col-6 p-3 bg-light">
              <strong>Election Result Document *</strong>
            </div>
            <div className="col-6 p-3">
              <input
                className="form-control"
                type="file"
                name="electionResultDoc"
                onChange={(e) => handleFileChange(e, "electionResultDoc")}
                accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
              />
              {resubmitDocs.electionResultDoc && (
                <small className="text-success">✓ Uploaded</small>
              )}
              {errors.electionResultDoc && (
                <small className="text-danger">{errors.electionResultDoc}</small>
              )}
            </div>
          </div>
        )}
              
                   {isDocRejected('approvedStaffDoc') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Approved Staff Document *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="file"
                        name="approvedStaffDoc"
                        onChange={(e) => handleFileChange(e, "approvedStaffDoc")}
                        accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                      />
                      {resubmitDocs.approvedStaffDoc && (
                        <small className="text-success">✓ Uploaded</small>
                      )}
                      {errors.approvedStaffDoc && (
                        <small className="text-danger">{errors.approvedStaffDoc}</small>
                      )}
                    </div>
                  </div>
                )}
                   {isDocRejected('lastAuditDoc') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Last Audit Document *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="file"
                        name="approvedStaffDoc"
                        onChange={(e) => handleFileChange(e, "lastAuditDoc")}
                        accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                      />
                      {resubmitDocs.lastAuditDoc && (
                        <small className="text-success">✓ Uploaded</small>
                      )}
                      {errors.lastAuditDoc && (
                        <small className="text-danger">{errors.lastAuditDoc}</small>
                      )}
                    </div>
                  </div>
                )}
                   {isDocRejected('byeLawsDoc') && (
                  <div className="d-flex border-bottom border-secondary">
                    <div className="col-6 p-3 bg-light">
                      <strong>Bye Laws Document *</strong>
                    </div>
                    <div className="col-6 p-3">
                      <input
                        className="form-control"
                        type="file"
                        name="byeLawsDoc"
                        onChange={(e) => handleFileChange(e, "byeLawsDoc")}
                        accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                      />
                      {resubmitDocs.byeLawsDoc && (
                        <small className="text-success">✓ Uploaded</small>
                      )}
                      {errors.byeLawsDoc && (
                        <small className="text-danger">{errors.byeLawsDoc}</small>
                      )}
                    </div>
                  </div>
                )}

        {/* Main Yard Details */}
        {isFieldRejected('mainYardDetails') && (
          <div className="border-bottom border-secondary p-3">
            <h5 className="mb-3">Main Yard Details *</h5>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">Name</label>
                <input
                  className="form-control"
                  type="text"
                  name="mainYardName"
                  value={formData.mainYardName || ""}
                  onChange={handleInputChange}
                  placeholder="Name of main yard"
                />
                {errors.mainYardName && (
                  <small className="text-danger">{errors.mainYardName}</small>
                )}
              </div>
              <div className="col-6">
                <label className="form-label">Date</label>
                <input
                  className="form-control"
                  type="date"
                  name="mainYardDate"
                  value={formData.mainYardDate || ""}
                  onChange={handleInputChange}
                />
                {errors.mainYardDate && (
                  <small className="text-danger">{errors.mainYardDate}</small>
                )}
              </div>
              <div className="col-6">
                <label className="form-label">Address</label>
                <input
                  className="form-control"
                  type="text"
                  name="mainYardAddress"
                  value={formData.mainYardAddress || ""}
                  onChange={handleInputChange}
                  placeholder="Address"
                />
                {errors.mainYardAddress && (
                  <small className="text-danger">{errors.mainYardAddress}</small>
                )}
              </div>
              <div className="col-12">
                <label className="form-label">Document</label>
                <input
                  className="form-control"
                  type="file"
                  name="mainYardDoc"
                  onChange={(e) => handleFileChange(e, "mainYardDoc")}
                  accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                />
                {formData.mainYardDoc && (
                  <small className="text-success">✓ Uploaded</small>
                )}
                {errors.mainYardDoc && (
                  <small className="text-danger">{errors.mainYardDoc}</small>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Sub Yards */}
        {isFieldRejected('subYardDetails') && (
          <div className="border-bottom border-secondary p-3">
            <h5 className="mb-3">Sub Yard Details *</h5>
            {(formData.subYards || []).map((subYard: SubYard, index: number) => (
              <div key={index} className="border rounded p-3 mb-3 position-relative bg-light">
                {formData.subYards && formData.subYards.length > 1 && (
                  <button
                    type="button"
                    className="btn text-danger position-absolute"
                    style={{ top: '8px', right: '8px', fontSize: "20px" }}
                    onClick={() => handleRemoveSubYard(index)}
                  >
                    ×
                  </button>
                )}
                <div className="mb-2">
                  <strong>Sub Yard {index + 1}</strong>
                </div>
                <div className="row g-3">
                  <div className="col-12">
                    <input
                      className="form-control"
                      type="text"
                      value={subYard.name || ''}
                      onChange={(e) => handleSubYardChange(index, 'name', e.target.value)}
                      placeholder="Name of Sub yard"
                    />
                    {errors?.[`subYards[${index}].name`] && (
                      <small className="text-danger">{errors[`subYards[${index}].name`]}</small>
                    )}
                  </div>
                  <div className="col-6">
                    <input
                      className="form-control"
                      type="date"
                      value={subYard.date || ''}
                      onChange={(e) => handleSubYardChange(index, 'date', e.target.value)}
                    />
                    {errors?.[`subYards[${index}].date`] && (
                      <small className="text-danger">{errors[`subYards[${index}].date`]}</small>
                    )}
                  </div>
                  <div className="col-6">
                    <input
                      className="form-control"
                      type="text"
                      value={subYard.address || ''}
                      onChange={(e) => handleSubYardChange(index, 'address', e.target.value)}
                      placeholder="Address"
                    />
                    {errors?.[`subYards[${index}].address`] && (
                      <small className="text-danger">{errors[`subYards[${index}].address`]}</small>
                    )}
                  </div>
                  <div className="col-12">
                    <input
                      className="form-control"
                      type="file"
                      name={`subYardDoc${index}`}
                      onChange={(e) => handleFileChange(e, 'subYardDoc', index)}
                      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                    />
                    {subYard.doc && (
                      <small className="text-success mt-1">✓ Uploaded</small>
                    )}
                    {errors?.[`subYards[${index}].doc`] && (
                      <small className="text-danger">{errors[`subYards[${index}].doc`]}</small>
                    )}
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-outline-info"
              onClick={handleAddSubYard}
            >
              + Add Another Sub Yard
            </button>
          </div>
        )}

       
      </div>
  {  applicationId?.buttonName.length > 0  && 
                  <div className="row m-1">
                    <textarea
                    className="form-control mb-2 "
                    placeholder="Enter your comment"
                    name="currAt"
                    value={comment!=""? comment : ""} // Bind value to state
                    onChange={(e) => setComment(e.target.value)} // Update state on type
                    rows={4} // Adjust number of rows as needed
                    required
                  />

                      <div className="d-flex gap-2 ">
                        {applicationId?.buttonName.map((button) => (
                          <button
                            key={button?.status}
                            className="btn btn-success h-10 w-10"
                            onClick={() => handleSubmit(button?.status , button?.appStatusLevel)}
                            disabled={submitLoading}
                          >
                            Resubmit
                          </button>
                          
                        ))}
                        <ToastContainer position="top-center" autoClose={3000} />
                        
                      </div>

                  </div>}
    </div>
  );
};

export default ResubmissionForm;